import React, { useCallback } from 'react';
import { router } from '@inertiajs/react';
import { cn } from '../utils/cn';
import { SearchInput } from './SearchInput';
export const FilterBar = React.forwardRef(function FilterBar(
  { url, filters, search, className },
  ref,
) {
  const handleFilterChange = useCallback(
    (param, value) => {
      const params = {};
      // Collect current filter values
      for (const filter of filters) {
        if (filter.param === param) {
          if (value) params[filter.param] = value;
        } else if (filter.value) {
          params[filter.param] = filter.value;
        }
      }
      router.visit(url, {
        data: params,
        preserveState: true,
        preserveScroll: true,
        replace: true,
      });
    },
    [url, filters],
  );
  return (
    <div ref={ref} className={cn('flex flex-wrap items-center gap-3', className)}>
      {search && (
        <SearchInput
          url={url}
          paramName={search.paramName}
          defaultValue={search.value}
          placeholder={search.placeholder}
          className="w-full sm:w-64"
        />
      )}
      {filters.map((filter) => (
        <div key={filter.param} className="flex items-center gap-1.5">
          <label
            htmlFor={`filter-${filter.param}`}
            className="text-sm font-medium text-fg-secondary"
          >
            {filter.label}
          </label>
          <select
            id={`filter-${filter.param}`}
            value={filter.value || ''}
            onChange={(e) => handleFilterChange(filter.param, e.target.value)}
            className={cn(
              'rounded-md border border-edge bg-surface px-3 py-1.5 text-sm',
              'text-fg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/25',
              'transition-colors duration-150',
            )}
          >
            <option value="">All</option>
            {filter.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
});
